import { PdfViewerPage as PlatformPdfViewerPage } from '@jarvis/platform-ui';

export function PdfViewerPage() {
  return <PlatformPdfViewerPage filesLinkTo="/files" filesLinkLabel="Files" />;
}
